import { useMutation, useQuery } from '@tanstack/react-query';
import {
    createApiKey,
    createOAuthClientForApiKey,
    getApiKeyCapabilities,
    getApiKeys,
    rotateApiKey,
    updateApiKey,
} from './apiKeysApi';

export const createApiKeyHooks = ({ queryClient }) => {
    const useApiKeys = () =>
        useQuery({
            queryKey: ['apiKeys'],
            queryFn: getApiKeys,
        });

    const useApiKeyCapabilities = () =>
        useQuery({
            queryKey: ['apiKeyCapabilities'],
            queryFn: getApiKeyCapabilities,
        });

    const useCreateApiKey = () =>
        useMutation({
            mutationFn: createApiKey,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
            },
        });

    const useRotateApiKey = () =>
        useMutation({
            mutationFn: rotateApiKey,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
            },
        });

    const useUpdateApiKey = () =>
        useMutation({
            mutationFn: updateApiKey,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
            },
        });

    const useCreateOAuthClientForApiKey = () =>
        useMutation({
            mutationFn: createOAuthClientForApiKey,
        });

    return {
        useApiKeys,
        useApiKeyCapabilities,
        useCreateApiKey,
        useRotateApiKey,
        useUpdateApiKey,
        useCreateOAuthClientForApiKey,
    };
};
